module.exports = __webpack_public_path__ + "static/img/f_mzjg_icon.png";